import classNames from 'classnames';
import React from 'react';

import { OptionCheckmark } from '@/components/OptionCheckmark';
import { useAccount } from '@/hooks/useAccount';
import { webSubscriptionsModule } from '@/modules/subscriptions';
import { StripeV2SubscriptionPrice } from '@/services/stripe/dto';

import { SimpleSubscriptionData } from './components/SimpleSubscriptionData';
import './SubscriptionButton.scss';

export const SimpleSubscriptionButton: React.FC<{
  subscription: StripeV2SubscriptionPrice;
  selected: boolean;
  disabled?: boolean;
  fullDisabled?: boolean;
  renderDiscount?: boolean;
}> = ({ subscription, selected, disabled, fullDisabled, renderDiscount }) => {
  const { currentUser } = useAccount();

  const needToRenderLabel = subscription.id === 'pro.1y';

  const plan = webSubscriptionsModule.getPlanConfig(subscription);

  return (
    <div
      className={classNames('app-subscriptions-button', {
        selected,
        disabled: fullDisabled || disabled,
        'with-label': needToRenderLabel,
        'fully-disabled': fullDisabled,
      })}
      onClick={() => {
        currentUser.setSelectedPlanId(subscription.id);
      }}
    >
      {needToRenderLabel && (
        <div className="app-subscriptions-button__label">SAVE 80%</div>
      )}

      <div className={classNames('app-subscriptions-button__content')}>
        <div className="app-subscriptions-button__content-container">
          <OptionCheckmark
            checked={selected}
            className="app-subscriptions-button__checkmark"
            theme="light"
          />

          <SimpleSubscriptionData
            plan={plan}
            soldOut={fullDisabled}
            renderDiscount={renderDiscount}
            subscription={subscription}
          />
        </div>
      </div>
    </div>
  );
};
